define('sections/sessions/Podio.UI.Login',['require','jquery','lib/Podio.Event','lib/Podio.Event.UI','lib/Podio.FormValidation','react','react-dom','lib/Podio.Tracking.Pendo','component!LoginComponent'],function(require) {

  var $ = require('jquery');
  var podioEvent = require('lib/Podio.Event');
  var eventUI = require('lib/Podio.Event.UI');
  var formValidation = require('lib/Podio.FormValidation');

  var React = require('react');
  var ReactDOM = require('react-dom');
  require('lib/Podio.Tracking.Pendo');

  var LoginComponent = require('component!LoginComponent');

  function onInit() {
    var loginComponentContainer = document.getElementById('login-component');

    function getElementByIdOrEmpty(ele) {
      return document.getElementById(ele) ? document.getElementById(ele).value : '';
    }

    if (loginComponentContainer) {
      var props = {
        return_to: getElementByIdOrEmpty('return_to'),
        offering_id: getElementByIdOrEmpty('offering_id'),
        subtype: getElementByIdOrEmpty('subtype'),
        remember_me: getElementByIdOrEmpty('sso_remember_me'),
        timezone: getElementByIdOrEmpty('timezone'),
        source_id: getElementByIdOrEmpty('source_id'),
        source_type: getElementByIdOrEmpty('source_type')
      };

      ReactDOM.render(React.createElement(LoginComponent, props), loginComponentContainer);
    } else {
      var elmLoginForm = $('.login-box form.main-login');
      formValidation.init(elmLoginForm);
    }
  }

  function onRememberMeCheckboxChange(elmTarget, e) {
    $('#sso_remember_me').prop('value', elmTarget.prop('checked') ? '1' : '0');
  }

  podioEvent.bind(podioEvent.Types.init, onInit);
  eventUI.bind('change', '#remember_me', onRememberMeCheckboxChange, true);

});

